import { Component, Mixins } from 'vue-property-decorator';
import CalendarText from '../text';
import { MONTHS } from './const';
import Props from './props';

const getMonthText = (value: number) => MONTHS[String(value + 1)];

@Component({
  components: { CalendarText }
})
export default class CalendarCard extends Mixins(Props) {
  // Computed
  get date() {
    return this.value.getDate();
  }

  get day() {
    return this.value.getDay();
  }

  get isWeekend() {
    return this.day === 6 || this.day === 0;
  }

  get month() {
    return this.value.getMonth();
  }

  get monthText() {
    return getMonthText(this.month);
  }
}



// WEBPACK FOOTER //
// ./src/components/calendar/card/script.ts